import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const useLogic = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return { isMobile };
};
